import styles from '../../search.module.scss'
import Icon from '@/components/styleguide/Icon'
import { Size } from '@/types/system'

type ElectricMinMaxSelectProps = {
  activeMin?: number | undefined
  activeMax?: number | undefined
  availableMinimum: number[]
  availableMaximum: number[]
  handleMaxInput: (value?: number | undefined) => void
  handleMinInput: (value?: number | undefined) => void
  title: string
  filter: string
}

export const ElectricMinMaxSelect = ({
  activeMin,
  activeMax,
  availableMaximum,
  availableMinimum,
  handleMinInput,
  handleMaxInput,
  title,
  filter,
}: ElectricMinMaxSelectProps) => {
  const hasOptions = !!(
    (availableMinimum.length > 0 && availableMaximum.length > 0) ||
    activeMin ||
    activeMax
  )

  if (!hasOptions) {
    return (
      <p className={styles['error-text']}>
        {`There are no "${title}" options available based on your current filter selections.`}
      </p>
    )
  }

  return (
    <div className={styles.minmax}>
      <div className={styles.selects}>
        <span className={styles.label}>Min</span>
        <div className={styles.select}>
          <select
            className={styles.control}
            id={`${filter}-min`}
            title={`${title} minimum`}
            onChange={e =>
              handleMinInput(e.target.value ? parseInt(e.target.value, 10) : undefined)
            }
            value={activeMin || ''}>
            <option value="">Any</option>
            {availableMinimum.map(item => (
              <option
                value={item}
                key={item}>
                {item}kWh
              </option>
            ))}
          </select>
          <Icon
            customClass={styles.icon}
            name="ChevronDown"
            size={Size.Medium}
          />
        </div>
      </div>
      <div className={styles.selects}>
        <span className={styles.label}>Max</span>
        <div className={styles.select}>
          <select
            className={styles.control}
            id={`${filter}-max`}
            title={`${title} maximum`}
            onChange={e =>
              handleMaxInput(e.target.value ? parseInt(e.target.value, 10) : undefined)
            }
            value={activeMax || ''}>
            <option value="">Any</option>
            {availableMaximum.map(item => (
              <option
                value={item}
                key={item}>
                {item}kWh
              </option>
            ))}
          </select>
          <Icon
            customClass={styles.icon}
            name="ChevronDown"
            size={Size.Medium}
          />
        </div>
      </div>
    </div>
  )
}
